import { render, staticRenderFns } from "./loading-animation.vue?vue&type=template&id=0079bd7d&scoped=true"
import script from "./loading-animation.vue?vue&type=script&lang=js"
export * from "./loading-animation.vue?vue&type=script&lang=js"
import style0 from "./loading-animation.vue?vue&type=style&index=0&id=0079bd7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0079bd7d",
  null
  
)

export default component.exports